import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CardManagementPageComponent } from './card-management-page/card-management-page.component';
import { LearningPageComponent } from './learning-page/learning-page.component';

const routes: Routes = [
  {
    path: 'card-management',
    component: CardManagementPageComponent,
  },
  {
    path: 'learning',
    component: LearningPageComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
